import { combineReducers } from '@reduxjs/toolkit';
import claimsReducer from './claimsSlice';
import messagingReducer from './messagingSlice';
import userReducer from './userSlice';
import patientReducer from './patientSlice';
import lawyerReducer from './lawyerSlice';
import employerReducer from './employerSlice';
import insuranceReducer from './insuranceSlice';
import notesReducer from './notesSlice';
import providerReducer from './providerSlice';
import documentsReducer from './documentsSlice';
import callAgentReducer from './callAgentSlice';
import unifiedCallReducer from './unifiedCallSlice';
import activityLogReducer from './activityLogSlice';
import vectorReducer from './vectorSlice';
import appointmentReducer from './appointmentSlice';
import calendarReducer from './calendarSlice';
import chatQuestionsReducer from './chatQuestionsSlice';
import dataAgentSessionReducer from './dataAgentSessionSlice';
import dataAgentReducer from './dataAgentSlice';
import pharmacyReducer from './pharmacySlice';
import providerQuestionnaireReducer from './providerQuestionnaireSlice';
import queryProgressReducer from './queryProgressSlice';
import questionnaireReducer from './questionnaireSlice';
import realtimeReducer from './realtimeSlice';
import redFlagResolutionReducer from './redFlagResolutionSlice';
import redFlagReducer from './redFlagSlice';
import summaryReducer from './summarySlice';
import templateReducer from './templateSlice';
import userProfileReducer from './userProfileSlice';
import authReducer from './authSlice';
import emailReducer from './emailSlice';
import batchesReducer from './batchesSlice';
import analyticsReducer from './analyticsSlice';
import refillsReducer from './refillsSlice';
import reconciliationReducer from './reconciliationSlice';
import dashboardReducer from './dashboardSlice';
import taskReducer from './taskSlice';
import taskNotificationReducer from './taskNotificationSlice';
import emailSignatureReducer from './emailSignatureSlice';
import predictiveReducer from './predictiveSlice';

const rootReducer = combineReducers({
  user: userReducer,
  claims: claimsReducer,
  patients: patientReducer,
  lawyers: lawyerReducer,
  employers: employerReducer,
  insurances: insuranceReducer,
  notes: notesReducer,
  providers: providerReducer,
  documents: documentsReducer,
  callAgent: callAgentReducer,
  unifiedCall: unifiedCallReducer,
  activityLog: activityLogReducer,
  appointment: appointmentReducer,
  calendar: calendarReducer,
  chatQuestions: chatQuestionsReducer,
  dataAgentSession: dataAgentSessionReducer,
  dataAgent: dataAgentReducer,
  pharmacy: pharmacyReducer,
  providerQuestionnaire: providerQuestionnaireReducer,
  queryProgress: queryProgressReducer,
  questionnaire: questionnaireReducer,
  realtime: realtimeReducer,
  redFlagResolution: redFlagResolutionReducer,
  redFlag: redFlagReducer,
  summary: summaryReducer,
  template: templateReducer,
  userProfile: userProfileReducer,
  messaging: messagingReducer,
  auth: authReducer,
  vector: vectorReducer,
  emails: emailReducer,
  batches: batchesReducer,
  analytics: analyticsReducer,
  refills: refillsReducer,
  reconciliation: reconciliationReducer,
  dashboard: dashboardReducer,
  tasks: taskReducer,
  taskNotifications: taskNotificationReducer,
  emailSignature: emailSignatureReducer,
  predictive: predictiveReducer
});

export default rootReducer;
